import React, { Component } from 'react';
import './Accordion.Module.scss';

/**
 * import fontawesome icons
 */
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faAngleDown} from '@fortawesome/pro-regular-svg-icons';

class Accordion extends Component {

    constructor(props) {
        super(props);
        this.state = {accordionState: this.props.defaultState};
    
        // This binding is necessary to make `this` work in the callback
        this.handleAccordionClick = this.handleAccordionClick.bind(this);
    }

    handleAccordionClick() {
        this.setState({
            accordionState: !this.state.accordionState         
        });
    }  

    render() {
        return (
            <div styleName="accordion">
                <div styleName={`accordion-head ${this.state.accordionState ? 'opened' : ''}`} onClick={() => this.handleAccordionClick()}>
                    <h3>
                        {this.props.title.toUpperCase()}
                        <FontAwesomeIcon styleName={`icon ${this.state.accordionState ? 'rotated' : ''}`} icon={faAngleDown} />
                    </h3>
                    <h6></h6>
                    <div styleName="leftElement">
                        {this.props.leftElement}
                    </div>
                </div>
                <div styleName={`accordion-body ${this.state.accordionState ? 'opened' : ''}`}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Accordion;